import React, { useState } from 'react'
// import Forms from '../forms'
import Card from '../card'
import OrdersMenu from './OrdersMenu'
import Layout from './Layout'
import FormSwitch from './FormSwitch'
import plants from "../../vendor/media/Plants_R1 (1).png";
import Icons from '../icons'


const OpenOrders = ({ tab, changeTab, matters, orders, user, reload, formManager }) => {
    const [active, setActive] = useState(0)

    return (
        <>
            <Layout.Main>
                <Layout.Left.Main>
                    <OrdersMenu tab={tab} changeTab={changeTab} />
                    <Layout.Left.New>
                        <button className='btn-primary' onClick={() => formManager.open('newMatter')}>CREATE NEW MATTER +</button>
                        {/* <button className='btn-green new-item-button' onClick={() => formManager.open('newOrder')}> New Order </button><br /><br /> */}
                    </Layout.Left.New>
                    <Layout.Left.List>
                        {
                            orders.length > 0 ?
                                orders.map((o, n) => <Card.Order
                                    key={n ^ 4 * 0.179}
                                    order={o}
                                    matters={matters}
                                    active={n === active}
                                    setActive={(closeForm) => {
                                        if (closeForm) {
                                            formManager.close()
                                        }
                                        setActive(n)
                                    }}
                                />)
                                :
                                <>
                                    <span className="ontrial-copy"> Looks like you haven't opened an order, yet. Select a matter to get started. </span>
                                    <br/>
                                    <span className="ontrial-copy"> Once you've opened an order, this is where they'll appear. </span>
                                </>
                        }
                    </Layout.Left.List>
                </Layout.Left.Main>
                <Layout.Right.Main>
                    <FormSwitch
                        formManager={formManager}
                        user={user}
                        reload={reload}
                        renderDefault={() => (
                            orders.length > 0 ?
                                <Card.Panel.Order order={orders[active]} matters={matters} /> :
                                ''
                        )}
                    />

                </Layout.Right.Main>

                {/* <img src={plants} className="plants" alt="Whoops!" /> */}
            </Layout.Main>


        </>
    )
}

export default OpenOrders